<div class="container">
    <div class="header"></div>
    <div class="title">O u p s ...!</div>
    <div class="message">{{ message }}</div>
    <div class="actions">
        <ng-content select=".actions"></ng-content>
    </div>
</div>
